import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import MediNearby from './MediNearby';

const dummyMedicines = [ 
  {
    id: 1,
    title: "Paracetamol 500mg",
    brief: "Common pain reliever and fever reducer. Fast-acting and widely used in mild to moderate pain cases.",
    type: "Allopathy",
    location: "Cipla Ltd, Mumbai",
    keywords: "",
    hasVoucher: true,
    image: "/api/downloads/thinkmedicine/medicines/1.png",
  },
  {
    id: 2,
    title: "Nux Vomica 30C",
    brief: "Homeopathic remedy commonly used for indigestion, nausea, and irritability. Derived from the poison nut tree.",
    type: "Homeopathy",
    location: "SBL Pvt Ltd, New Delhi",
    keywords: "",
    hasVoucher: false,
    image: "/api/downloads/thinkmedicine/medicines/2.png",
  },
  {
    id: 3,
    title: "Ashwagandha Capsules",
    brief: "Ayurvedic adaptogen known to reduce stress, improve stamina and support overall vitality.",
    type: "Ayurveda",
    location: "Patanjali Ayurved Ltd, Haridwar",
    keywords: "",
    hasVoucher: true,
    image: "/api/downloads/thinkmedicine/medicines/3.png",
  },
  {
    id: 4,
    title: "Biotin Gummies",
    brief: "Supports hair, skin, and nail health. Nutritional supplement rich in Vitamin B7.",
    type: "Nutraceutical",
    location: "HealthKart, Gurugram",
    keywords: "",
    hasVoucher: false,
    image: "/api/downloads/thinkmedicine/medicines/biotin.png",
  },
  {
    id: 5,
    title: "Bach Rescue Remedy",
    brief: "Natural flower remedy used to relieve stress, anxiety, and emotional imbalance.",
    type: "Bach Flower Remedy",
    location: "Nelsons, London, UK",
    keywords: "",
    hasVoucher: true,
    image: "/api/downloads/thinkmedicine/medicines/rescueremedy.png",
  }
];


const MediCatalogue = () => {
  const [filters, setFilters] = useState({
    type: '',
    location: '',
    keywords: '',
    hasVoucher: false,
  });
  const [results, setResults] = useState([]);
  const [nearbyClicked, setNearbyClicked] = useState(false);
  const navigate = useNavigate();

  const handleSearch = () => {
    const filtered = dummyMedicines.filter(medi =>
      (!filters.type || medi.type === filters.type) &&
      (!filters.location || medi.location.toLowerCase().includes(filters.location.toLowerCase())) &&
      (!filters.hasVoucher || medi.hasVoucher)
    );
    setResults(filtered);
  };

  const handleNearbyClicked = () => {
    setNearbyClicked(!nearbyClicked);
  };

  return (
    <div className="w-full p-6 bg-black border border-green-400 min-h-screen rounded-md shadow-inner">
      <h2 className="text-lg lg:text-xl font-extrabold mb-6 text-yellow-200">🌿 Find Your Medicine</h2>

      {/* Filters */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-6">
        <select 
          onChange={(e) => setFilters({ ...filters, type: e.target.value })}
          className="border border-yellow-500 p-2 rounded h-10 focus:ring-yellow-400"
        >
          <option value="">Select Type</option>
          {/* Options */}
          {[
            "Allopathy", "Homeopathy", "Ayurveda", "Unani", "Siddha",
            "Naturopathy", "Traditional Chinese Medicine", "Chiropractic",
            "Osteopathy", "Herbal Medicine", "Anthroposophic Medicine", "Integrative Medicine"
          ].map(type => <option key={type}>{type}</option>)}
        </select>

        <input 
          type="text"
          placeholder="Company"
          onChange={(e) => setFilters({ ...filters, location: e.target.value })}
          className="border border-yellow-500 p-2 rounded"
        />

        <input 
          type="text"
          placeholder="Keywords"
          onChange={(e) => setFilters({ ...filters, keywords: e.target.value })}
          className="border border-yellow-500 p-2 rounded"
        />
      </div>

      {/* Buttons */}
      <div className="flex flex-col md:flex-row justify-center gap-4 mb-8">
        <button 
          onClick={handleSearch}
          className="bg-yellow-400 text-green-900 font-semibold px-6 py-2 w-48 rounded-md shadow-md hover:bg-yellow-500 transition"
        >
          🔍 Search
        </button>

        <button 
          onClick={handleNearbyClicked}
          className="bg-green-700 text-white font-semibold w-60 px-6 py-2 rounded-md shadow-md hover:bg-green-800 transition"
        >
          🧭 Medicine Nearby
        </button>
      </div>

      {/* Results */}
      <div className="mt-2 space-y-6">
        {results.map(medi => (
          <div key={medi.id} className="bg-gray-200 border border-yellow-400 p-4 rounded-md shadow flex gap-6 items-center">
            <img src={medi.image} alt={medi.title} className="w-28 h-24 object-cover rounded-sm border border-green-200" />
            <div>
              <h3 className="text-md lg:text-lg font-bold text-green-800">{medi.title}</h3>
              <p className="text-gray-700 text-sm lg:text-md">{medi.brief}</p>
              <button 
                onClick={() => navigate(`/medi/${medi.id}`)}
                className="mt-2 bg-green-700 text-white px-4 py-1 rounded-md hover:bg-green-800 transition"
              >
                View Details
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* Nearby Component */}
      {nearbyClicked && <div className="mt-10"><MediNearby /></div>}
    </div>
  );
};

export default MediCatalogue;
